export default "__VITE_ASSET__CFZh6Auo__"